import { createSlice } from '@reduxjs/toolkit';
import { IMdbError } from '../../../errorObjects/MdbError';

const initialState: IMdbError | null = null;

export const themeSpecsSaveFailureSlice = createSlice({
  name: 'themeSpecsSaveFailure',
  initialState,
  reducers: {
    // action has a payload with an error
    themeSpecsSaveFailureChange(state, action) {
      return action.payload;
    },
        
    // action has a payload with a null value
    themeSpecsSaveFailureClear(state) {
      return null; // action.payload;
    },
  },
})

// Action creators are generated for each function in reducer)
export const { themeSpecsSaveFailureChange, themeSpecsSaveFailureClear } = themeSpecsSaveFailureSlice.actions;

// export the core reducer for the slice
export const themeSpecsSaveFailureReducer = themeSpecsSaveFailureSlice.reducer;

export default themeSpecsSaveFailureSlice.reducer;